/*********************** Custom JS for Boost AI Search & Discovery  ************************/
const isMobile = () => {
  let check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
}

const customize = {
  updateProductItem: (componentRegistry) => {
    componentRegistry.useComponentPlugin('ProductItem', {
      name: 'Modify Product Item Element',
      enabled: true,
      apply: () => ({
        afterRender(element){
          let productData = element.getParams().props.product;
          let productItem = document.querySelector('.boost-sd__product-item[data-product-id="'+ productData.id +'"]');

          if (!productItem) {
            return;
          }

          /* Product Badges */
          if (!productItem.querySelector('.boost-sd__product-badges')) {
            let badges = '<div class="boost-sd__product-badges">';
            if (!productData.available) {
              badges += `<div class="product-badge product-badge--sold-out">Sold Out</div>`;
            } else {
              productData.tags.length > 0 && productData.tags.forEach(tag => {
                const badge = (tag.includes('pfs:label-')) ? tag.split('pfs:label-')[1] : '';
                if (badge) {
                  const badgeHandle = badge.toLowerCase().replace(/ /g,'-');
                  badges += `<div class="product-badge product-badge--${badgeHandle}">${badge}</div>`;
                }
              });
            }

            badges += '</div>';

            productItem.insertAdjacentHTML('afterbegin', badges);
          }

          /* Try It Virtually Badge */
          if (!productItem.querySelector('.boost-sd__product-try-virutal')) {
            productData.tags.length > 0 && productData.tags.forEach(tag => {
              const value = (tag.includes('tryOnVirtually:')) ? tag.split('tryOnVirtually:')[1] : '';
              if (value && value.toLowerCase() == 'true') {
                const tryVirtualBadge = document.createElement('div');
                tryVirtualBadge.setAttribute('class', 'boost-sd__product-try-virutal');
                tryVirtualBadge.innerHTML = `
                  <span>Try it on virtually</span>
                  <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.10693 2.51648H10.4186V3.77459H8.10693V2.51648Z" fill="currentColor"/>
                    <path d="M17.9313 8.64339C17.9313 8.08354 17.6828 7.25947 16.4923 6.49192L15.9028 7.5739C16.4576 7.93245 16.7755 8.32248 16.7755 8.64959C16.7755 9.19689 15.9375 9.87627 14.4638 10.3921V1.89345C14.4638 0.849218 13.6837 0 12.7243 0H5.79509C4.83575 0 4.05557 0.849238 4.05557 1.89345V8.80041H5.2114V1.89345C5.2114 1.54746 5.47146 1.25812 5.79509 1.25812H12.7243C13.0422 1.25812 13.308 1.54118 13.308 1.89345V10.7192C12.3545 10.9456 11.2275 11.1029 9.95038 11.1469L11.401 9.568L10.5861 8.68104L7.72538 11.7949L10.5861 14.9088L11.401 14.0218L9.92149 12.4115C11.0831 12.3737 12.2389 12.2353 13.3022 12.0026V16.991C13.3022 17.337 13.0422 17.6263 12.7186 17.6263H5.78932C5.47146 17.6263 5.20563 17.3432 5.20563 16.991V13.1035H4.0498V16.991C4.0498 18.0352 4.83 18.8844 5.78932 18.8844H12.7186C13.6779 18.8844 14.4581 18.0352 14.4581 16.991V11.7006C16.475 11.0716 17.9256 10.0462 17.9256 8.656L17.9313 8.64339Z" fill="currentColor"/>
                    <path d="M6.45388 10.9585C3.40249 10.5056 1.74956 9.42358 1.74956 8.64355C1.74956 8.32272 2.06742 7.93272 2.62222 7.56785L2.03275 6.48587C0.842244 7.25332 0.59375 8.08368 0.59375 8.63735C0.59375 10.6378 3.54121 11.7889 6.2919 12.1979L6.44793 10.9524L6.45388 10.9585Z" fill="currentColor"/>
                  </svg>
                `;
                productItem.prepend(tryVirtualBadge);

                return false;
              }
            });
          }

          /* Product Summary */
          if (!productItem.querySelector('.boost-sd__product-summary')) {
            let summary = document.createElement('div');
            summary.setAttribute('class', 'boost-sd__product-summary');
            productData.metafields.length > 0 && productData.metafields.forEach(metafield => {
              if (metafield.namespace == 'custom' && metafield.key == 'product_summary') {
                summary.innerHTML = metafield.value;
                return false;
              }
            });
            productItem.querySelector('.boost-sd__product-title').after(summary);
          }

          /* Campaign 1 Product */
          if (!productItem.classList.contains('.boost-sd__product-item--campaign-1')) {
            let campaignPrice = '';
            let campaignMessage = '';
            productData.tags.length > 0 && productData.tags.forEach(tag => {
              campaignPrice = (tag.indexOf('CampaignOriginalPrice:') > -1) ? tag.split('CampaignOriginalPrice:')[1] : campaignPrice;
              campaignMessage = (tag.indexOf('CampaignMessage:') > -1) ? tag.split('CampaignMessage:')[1] : campaignMessage;
            });

            if (campaignPrice) {
              productItem.querySelector('.boost-sd__product-price-content').innerHTML = `
                <div class="flex items-center gap-2.5">
                  <span class="sub-large text-secondary">${campaignMessage}</span>
                  <span class="boost-sd__format-currency"><span>${campaignPrice}</span></span>
                </div>
              `;
              productItem.classList.add('boost-sd__product-item--campaign-1')
            } else {
              /* Pro Discount Pricing */
              const body = document.querySelector(`body`);
              const pro = body.dataset.proUser;
              console.log('pro user', pro);
              const discount = body.dataset.discount;
              const tier = body.dataset.tier;
              const proDiscount = {
                pro: (pro) ? (pro === 'true' ? true : false) : false,
                discount: (discount) ? Number(discount) : 0,
                tier: (tier) ? tier : ''
              };
              console.log('proDiscount PLP', proDiscount);
              //console.log('productData PLP', productData);
              //productData.compare_at_price_max
              //productData.price_max
              let showDiscount = false;
              let msrpDiscount = 0;
              // if (productData.compare_at_price_max && productData.compare_at_price_max > 0) {
              //   msrpDiscount = ((100 - proDiscount.discount) / 100) * productData.compare_at_price_max;
              //   if (msrpDiscount < productData.price_max) {
              //     showDiscount = true;
              //   }
              // } else {
              //   msrpDiscount = ((100 - proDiscount.discount) / 100) * productData.price_max;
              //   showDiscount = true;
              // }
              msrpDiscount = ((100 - proDiscount.discount) / 100) * productData.price_max;
              showDiscount = true;
              if (showDiscount && proDiscount.pro) {
                console.log('show discount');
                console.log(productData.title, msrpDiscount.toFixed(2));
                productItem.querySelector('.boost-sd__product-price-content').innerHTML = `
                  <div style="flex: 100%;">
                    <span class="boost-sd__format-currency" style="color: rgb(34, 34, 34); text-decoration: line-through;"><span class="">$${productData.price_max}</span></span>
                  </div>
                  <div class="flex flex-col md:flex-row items-start mt-0 md:-mt-1.5 md:items-center">
                    <span class="sub-large text-secondary mr-2.5" style="font-size: 16px;">${proDiscount.tier}:</span>
                    <span class="boost-sd__format-currency text-secondary" style="font-size: 16px;"><span>$${msrpDiscount.toFixed(2)}</span></span>
                  </div>
                `;
                //TODO: quickview pricing?
              }
            }
          }

          /* Custom Promo Messages */
          if (!productItem.querySelector('.boost-sd__product-promo-messages')) {
            let promoMessages = '<div class="boost-sd__product-promo-messages">';

            productData.tags.length > 0 && productData.tags.forEach(tag => {
              const message = (tag.includes('PromoTag:')) ? tag.split('PromoTag:')[1] : '';
              if (message) {
                promoMessages += `<p>${message}</p>`;
              }
            });
            promoMessages += '</div>';
            productItem.querySelector('.boost-sd__product-info').insertAdjacentHTML('beforeend', promoMessages);
          }

          /* Change position of ATC */
          if (isMobile() || window.innerWidth < 769) {
            if (productItem.querySelector('.boost-sd__product-link-image .boost-sd__button')) {
              productItem.querySelector('.boost-sd__product-info').append(productItem.querySelector('.boost-sd__product-link-image .boost-sd__button'));
            }
          }
        }
      }),
    });

    componentRegistry.useComponentPlugin('ProductSwatch', {
      name: 'Customize swatches',
      enabled: true,
      apply: () => ({
          props: (props, element) => {
            console.log(props);
              if (props.isQuickView || props.isPopupSelectOption) {
                props.maxItem = 100;
              } else {
                props.maxItem = 10;
                if (isMobile() || window.innerWidth < 769) {
                  props.maxItem = 4;
                }
              }

              return props;
          }
      }),
    });

    componentRegistry.useComponentPlugin('SearchProductItem', {
      name: 'Modify Search Product Item Element',
      enabled: true,
      apply: () => ({
        afterRender(element){
          let productData = element.getParams().props.product;
          let productItem = document.querySelector('.boost-sd__suggestion-queries-item--product[data-id="'+ productData.id +'"]');

          if (!productItem) {
            return;
          }

          /* Campaign 1 Product */
          if (!productItem.querySelector('.boost-sd__suggestion-queries-item-amount.boost-sd__campaign-price')) {
            let campaignPrice = '';
            let campaignMessage = '';
            productData.tags.length > 0 && productData.tags.forEach(tag => {
              campaignPrice = (tag.indexOf('CampaignOriginalPrice:') > -1) ? tag.split('CampaignOriginalPrice:')[1] : campaignPrice;
              campaignMessage = (tag.indexOf('CampaignMessage:') > -1) ? tag.split('CampaignMessage:')[1] : campaignMessage;
            });

            if (campaignPrice) {
              productItem.querySelector('.boost-sd__suggestion-queries-item-amount').innerHTML = `
                <div class="flex items-center gap-2.5">
                  <span class="sub-regular text-secondary">${campaignMessage}</span>
                  <span class="boost-sd__format-currency"><span>${campaignPrice}</span></span>
                </div>
              `;
              productItem.querySelector('.boost-sd__suggestion-queries-item-amount').classList.add('boost-sd__campaign-price');
            }
          }
        }
      }),
    });

    componentRegistry.useComponentPlugin('ProductSwatchOption', {
      name: 'Add event click redirect PDP',
      apply: () => ({
          props(props, element) {
            if (!props.isPopupSelectOption && !props.isQuickView) {
              props.onSelect = (value) => {
                const productData = element.getParentElm().getParentElm().getParams().props.data;
                const selectedVariant = productData?.variants.find(item => {
                  if (item.title.includes('/')) {
                    let newItem = item.title.split("/");
                    console.log({newItem})
                    return newItem[0].trim() === value;
                  } else {
                    return item.title === value
                  }
                });

                if (selectedVariant) {
                    const localeURLPart = (window?.Shopify?.routes?.root || '/')?.replace(/\/$/, '');
                    window.location.href = `${localeURLPart}/products/${productData.handle}?variant=${selectedVariant.id}`;
                };
              }
            }

            return props;
          },
      }),
    });
  }
}



window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([customize.updateProductItem]);

let windowWidth = 0; // Initialize the windowWidth variable to store the width.
const _checkIsMobile = () => {
   if (!windowWidth) {
      // We don't want to re-calculate the width every time because it causes a style recalculation every time.
      // So we store it
      windowWidth = window.innerWidth;

      // Calculate the width on resize
      window.addEventListener('resize', () => {
         windowWidth = window.innerWidth;
      });
   }
   return windowWidth <= 768;
};

// Check isCollectionPage
const isCollectionPage = () => {
   return window.location.pathname.includes('/collections');
};

const cardCTA = boostSDData?.card_CTA;
const cardCTAColumns = boostSDData?.card_CTA?.columns;

// Adjust pagination
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat((registry) => {
   registry.useModulePlugin('FilterAPI', {
      name: 'Extra params filter in collection page',
      apply(builder) {
         builder.on('beforeMethodCall', 'get', (payload) => {
            if (cardCTAColumns) {
               payload.args[1].limit = payload.args[1].limit - parseFloat(cardCTAColumns);
            }
         });
      },
   });
});

const customBanner = {
   productListAfterRender: (componentRegistry) => {
      let preventReCallProductHandlesTheSame = [];
      componentRegistry.useComponentPlugin('ProductList', {
         name: 'Product List After Render',
         enabled: true,
         apply: () => ({
            afterRender(element) {
               if (!isCollectionPage()) return;
               try {
                  // Start customization ---------------------------------------
                  const helpersRef = element.getHelpers();
                  // Function get all handles displayed in product list
                  const productHandles = helpersRef.getProductHandles();
                  // Check duplicate not call. prevent call multi the same value
                  const isDuplicate = JSON.stringify(preventReCallProductHandlesTheSame) === JSON.stringify(productHandles);
                  preventReCallProductHandlesTheSame = productHandles;

                  if (productHandles?.length && !isDuplicate) {
                    var elements = document.getElementsByClassName("boost-sd__custom-card-CTA");
                    // Convert the HTMLCollection to an array for easier manipulation
                    var elementsArray = Array.from(elements);
                    // Remove each element
                    elementsArray.forEach(function(element) {
                        element.remove();
                    });

                     // Add general card
                     if (cardCTA) {
                        insertCard(cardCTA);
                     }
                  }
                  // End customization ---------------------------------------
               } catch (err) {
                  console.warn(err);
               }
            }
         })
      })
   }
}



window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([customBanner.productListAfterRender]);

function compileCardTemplate(cardCTA) {
   const {background_desktop, background_mobile, video, description, title, label, hyperlink, columns, overlay_position, text_color} = cardCTA;
   let cardTemplate = `
    <div
      class="boost-sd__product-item boost-sd__product-item--no-border boost-sd__product-item-grid-view-layout boost-sd__custom-card-CTA is-visible"
      data-columns="${columns}">
      <div class="boost-sd__CTA__inner">`;
        if (video) {
          cardTemplate += `
            <video class="boost-sd__CTA__video" muted autoplay loop>
              <source src="${video}" type="video/mp4">
              Your browser does not support the video tag.
            </video>
          `;
        } else {
          cardTemplate += `
            <img
              src="${_checkIsMobile() ? background_mobile : background_desktop }"
              class="boost-sd__CTA__img"
              alt="Campaign Card">
          `;
        }
    cardTemplate += `
        <div class="boost-sd__CTA-info-container ${text_color == 'White' ? 'text-white' : 'text-black'}" data-position="${overlay_position}">
          <h4 class="boost-sd__CTA__title">${title}</h4>
          <div class="boost-sd__CTA__desc">${description}</div>
          <a href="${hyperlink}" class="boost-sd__CTA__link focus-link ${text_color == 'White' ? 'white' : 'black'}">${label}</a>
        </div>
      </div>
    </div>`;
   return cardTemplate;
}

function insertCard(cardCTA) {
   const cardHTML = compileCardTemplate(cardCTA);

   const container = document.querySelector('.boost-sd__product-list');

   // Get the existing div at the specified index (if it exists)
   let cardIndex = cardCTA.cardIndex;
   const existingDiv = container.children[cardIndex - 2];

   // Insert the new div before the existing div (if found), or append it at the end
   if (existingDiv) {
      existingDiv.insertAdjacentHTML('afterend', cardHTML);
   }
}
